import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';
import { filter, round } from 'mathjs';

import ResearchService from '@service/industry-research';

const moMarketScale = observable({
  marketList: <any[]>[],
  xData: <any[]>[],
  marketData: <any[]>[],
  rateData: <any[]>[],
  filterMarket: <any[]>[],
  filterRate: <any[]>[],
});

const initMarketScale = action(async (res: any) => {
  const xArr: any[] = [];
  const xData: any[] = [];
  const marketArr: any[] = [];
  const rateArr: any[] = [];
  const filterMarketArr: any[] = [];
  const filterRateArr: any[] = [];

  res?.map((item: any) => {
    xArr.push(item.year);
    marketArr.push(item.market_size);
    rateArr.push(item.change_rate);
  });

  marketArr?.map((value: any) => {
    let newValue: number | string = '-';
    if (isNaN(value)) newValue = '-';
    else if (value === null || value === '' || value === undefined) newValue = '-';
    else newValue = Number(value).toLocaleString();
    filterMarketArr.push(`${newValue}亿`);
  });

  res?.map((item: any) => {
    let newValue: number | string = '-';
    if (isNaN(item.change_rate)) newValue = '-';
    else if (item.change_rate === null || item.change_rate === '' || item.change_rate === undefined) newValue = '-';
    else if (item.change_rate === 0) newValue = '0%';
    else newValue = `${round(item.change_rate * 100, 1)}%`;
    filterRateArr.push(newValue);
  });

  runInAction(() => {
    moMarketScale.marketList = res;
    moMarketScale.xData = xArr;
    moMarketScale.marketData = marketArr;
    moMarketScale.rateData = rateArr;
    moMarketScale.filterMarket = filterMarketArr;
    moMarketScale.filterRate = filterRateArr;
  });
});

export default moMarketScale;
export { initMarketScale };
